// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2d337632","703":"fde8112d"}[chunkId] + ".chunk.js";
};